export default "__VITE_ASSET__DdhWNPav__"